import React from 'react';
import { SaveButton, Checkbox } from '../../../../components';

const fields = [
  {
    key: 'image',
    label: 'Image',
    name: 'image'
  },
  {
    key: 'description',
    label: 'Description',
    name: 'description'
  },
  {
    key: 'datetime',
    label: 'Date n Time',
    name: 'datetime'
  },
  {
    key: 'location',
    label: 'Location/Media',
    name: 'location'
  },
  {
    key: 'testimonial',
    label: 'Testimoni',
    name: 'testimonial'
  },
  {
    key: 'gallery',
    label: 'Gallery',
    name: 'gallery'
  },
  {
    key: 'guest',
    label: 'Guest',
    name: 'guest'
  },
  {
    key: 'tag',
    label: 'Tag',
    name: 'tag'
  },
]

const defaultForm = {
  image: true,
  description: true,
  datetime: true,
  location: true,
  testimonial: true,
  gallery: true,
  guest: true,
  tag: true
}

const FormNew = ({handleClose}) => {
  const [form, setForm] = React.useState(defaultForm)

  const updateForm = (e) => {
    setForm({
      ...form,
      [e.target.name]: e.target.checked
    })
  }

  const handleSubmit = () => {
    console.log({form})
  }

  return <>
    <div className="mb-8" style={{columnCount: 2}}>
      { fields.map((field, index) => (
        <Checkbox
          className="mb-2"
          id={`${field.name}_${index}`}
          label={field.label}
          name={field.name}
          checked={form[field.name]}
          onChange={updateForm}
        />
      )) }
    </div>

    <div className="flex flex-wrap items-center">
      <div className="w-full md:w-auto lg:w-auto">
        <SaveButton type="button" mobileClassname="mb-5" onClick={handleSubmit}/>
      </div>
      <div className="w-full md:w-auto lg:w-auto text-center lg:text-left">
        <p className="cursor-pointer px-8 text-gray-444 underline text-xs lg:text-sm" onClick={handleClose}>Cancel</p>
      </div>
    </div>
  </>
}

export default FormNew
